export * from "./amount.component";
